import React, { ReactNode } from 'react';
import { StyleProp, StyleSheet, Pressable, ViewStyle } from 'react-native';
interface IconButtonProps {
  children: ReactNode;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
}

const IconButton = ({ children, style, onPress }: IconButtonProps) => {
  return (
    <Pressable style={[styles.container, style]} onPress={onPress} activeOpacity={0.7}>
      {children}
    </Pressable>
  );
};

export default IconButton;

const styles = StyleSheet.create({
  container: {
    padding: 10,
    marginHorizontal: 1,
  },
});
